import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import useAuth from '@/components/AppLayout/hooks/useAuth';

const AuthCallback = () => {
  const intl = useIntl();
  const { refresh } = useAuth();

  useEffect(() => {
    // handleRedirectPromise() is called inside AuthProvider on every mount.
    // By the time this component renders, the redirect has already been processed
    // and the account is set. refresh() picks up the account and acquires a token.
    refresh().then(() => {
      window.location.replace('/');
    });
  }, [refresh]);

  return <p>{intl.formatMessage({ id: 'completingLogin' })}</p>;
};

export default AuthCallback;
